export const getCustomer = interaction => {
  const customer = interaction?.participants?.find(participant => participant?.role === 'external')
  return customer || null
}

export const getFullName = (interaction, person = null) => {
  const user = !person ? getCustomer(interaction) : person
  if (!user) return 'Unknown user'
  const name      = user?.name,
        fullName  = user?.profile?.fullName,
        firstName = user?.profile?.firstName,
        lastName  = user?.profile?.lastName

  if (fullName === 'Anonymous' && name) return name
  if (fullName) return fullName
  if (firstName && lastName) return `${firstName} ${lastName}`
  if (name) return name
  if (firstName) return firstName
  if (lastName) return lastName
  
  return interaction?.threadId
}

export const getAssignedTo = interaction => {
  if (!interaction?.assignees) return '-'
  const lastAssignee = interaction.assignees?.filter(assignee => assignee?.completedAt === null)
  return lastAssignee.length ? lastAssignee[lastAssignee.length-1]?.actor?.name : '-'
}

export const getRepliedBy = interaction => {
  const actors = interaction?.participants
    ?.filter(participant => participant && (participant?.role === 'user' || participant?.role === 'moderator'))
  return actors?.length ? actors?.map(actor => getFullName(interaction, actor)).join(', ') : '-'
}

export const getUsernameFromSessionProfile = profile => {
  if(profile?.firstName && profile?.lastName) {
    return `${profile?.firstName} ${profile?.lastName}`
  } else if (profile?.firstName || profile?.lastName) {
    return profile?.firstName || profile?.lastName
  } else if(profile?.email) {
    return profile?.email
  } else {
    return 'Unknown username'
  }
}


